import PropTypes from 'prop-types';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import Loader from '../../../../../components/Loader';
import { useOrderContext } from '../../../../../providers/OrderProvider';

/**
 * 订单 modal：详情未就绪时在整页 modal-content（含 header/footer）上显示遮罩
 */
const OrderModalReadyGuard = ({ children }) => {
	const { isOrderReady } = useOrderContext();
	const [modalContent, setModalContent] = useState(null);

	const bindModalContent = (node) => {
		if (!node) {
			setModalContent(null);
			return;
		}
		setModalContent(node.closest('.modal-content'));
	};

	const overlay =
		!isOrderReady &&
		modalContent &&
		createPortal(
			<div className='order-modal-loading-overlay order-modal-loading-overlay--modal-content position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-body bg-opacity-75'>
				<Loader />
			</div>,
			modalContent,
		);

	return (
		<>
			<div ref={bindModalContent} className='order-modal-ready-guard'>
				{children}
			</div>
			{overlay}
		</>
	);
};

OrderModalReadyGuard.propTypes = {
	children: PropTypes.node.isRequired,
};

export default OrderModalReadyGuard;
